import { render, staticRenderFns } from "./md.vue?vue&type=template&id=f872a7c0&scoped=true&"
import script from "./md.vue?vue&type=script&lang=js&"
export * from "./md.vue?vue&type=script&lang=js&"
import style0 from "./md.vue?vue&type=style&index=0&id=f872a7c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f872a7c0",
  null
  
)

export default component.exports